export default __webpack_public_path__ + "static/media/lush4.c149c3de.webp";